import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { History, Search } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";

function fmtTime(ts) {
  return ts ? ts.slice(0, 16).replace("T", " ") : "";
}

export default function AuditLog() {
  const [items, setItems] = useState([]);
  const [search, setSearch] = useState("");
  const [role, setRole] = useState("");
  const [roles, setRoles] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/team/roles").then(({ data }) => setRoles(data)).catch(() => {});
  }, []);

  const load = async () => {
    setLoading(true);
    try {
      const params = {};
      if (search) params.search = search;
      if (role) params.role = role;
      const { data } = await api.get("/audit-log", { params });
      setItems(data);
    } catch {
      // keep previous items on error
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    load();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [role]);

  return (
    <div data-testid="audit-log-page">
      <h1 className="text-2xl font-bold text-slate-900 mb-1">Журнал действий</h1>
      <p className="text-sm text-slate-500 mb-5">Кто и когда что делал в личном кабинете</p>

      <div className="flex flex-wrap gap-2 mb-4">
        <Input
          placeholder="Поиск по сотруднику или документу"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          onKeyDown={(e) => e.key === "Enter" && load()}
          data-testid="audit-log-search-input"
          className="max-w-sm"
        />
        <Button variant="outline" onClick={load} data-testid="audit-log-search-button">
          <Search className="w-3.5 h-3.5 mr-1.5" />Найти
        </Button>
        <select
          value={role}
          onChange={(e) => setRole(e.target.value)}
          data-testid="audit-log-role-filter"
          className="border border-slate-200 rounded-lg px-3 text-sm bg-white h-9"
        >
          <option value="">Все должности</option>
          {roles.map((r) => (
            <option key={r.value} value={r.value}>{r.label}</option>
          ))}
        </select>
      </div>

      <div className="bg-white border border-slate-200 rounded-xl divide-y divide-slate-100">
        {!loading &&
          items.map((it) => (
            <div key={it.id} className="flex items-start gap-3 px-4 py-3 text-sm" data-testid={`audit-log-row-${it.id}`}>
              <History className="w-4 h-4 text-slate-400 mt-0.5 shrink-0" />
              <div>
                <div className="text-slate-800">
                  <span className="font-medium">{it.user_name}</span>
                  {it.position_label && <span className="text-slate-400"> ({it.position_label})</span>} — {it.action_label}
                  {it.target_label ? `: ${it.target_label}` : ""}
                </div>
                <div className="text-xs text-slate-400">{fmtTime(it.created_at)}</div>
              </div>
            </div>
          ))}
        {!loading && items.length === 0 && (
          <div className="py-16 text-center text-slate-400 text-sm" data-testid="audit-log-empty-state">
            Записей пока нет
          </div>
        )}
        {loading && <div className="py-16 text-center text-slate-400 text-sm">Загрузка…</div>}
      </div>
    </div>
  );
}
